export default {
  '100': 'LOW_VALUE',
  '500': 'MEDIUM_VALUE',
  '1000': 'HIGH_VALUE',
};
